import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const Home = () => import(/*webpackChukName:"home"*/ './views/home.vue');
const Apropos = () => import(/*webpackChukName:"apropos"*/ './views/apropos.vue');
const Devis = () => import(/*webpackChukName:"inscription"*/ './views/devis.vue');
const Appli = () => import(/*webpackChukName:"appli"*/ './views/appli.vue');
const Features = () => import(/*webpackChukName:"features"*/ './views/features.vue');
const Demo = () => import(/*webpackChukName:"demo"*/ './views/demo.vue');
const Soutien = () => import(/*webpackChukName:"soutien"*/ './views/soutien.vue');
const Test = () => import(/*webpackChukName:"test"*/ './views/test.vue');

const routes = [
	{ path: '/', component: Home, name:'home'},
	{ path: '/test', component: Test, name:'test'},
	{ path: '/inscription', component: Devis, name:'devis'},
	{ path: '/a-propos', component: Apropos, name:'a-propos'},
	{ path: '/application', component: Appli, name:'appli'},
	{ path: '/fonctionnalites', component: Features, name:'features'},
	{ path: '/demonstration', component: Demo, name:'demo'},
	{ path: '/nous-soutenir', component: Soutien, name:'soutien', props:(route) => ({ session: route.query.session, error: route.query.error })},
	{ path: '/confidentialite', beforeEnter(to, from, next) { window.location = '/documents/confidentialite.pdf' } },
	{ path: '/conditions-generales', beforeEnter(to, from, next) { window.location = '/documents/conditions-generales.pdf' } },
	{ path: '*', redirect: '/'},
];

const router = new VueRouter({
	routes,
	base: '/',
	linkActiveClass: "active",
	linkExactActiveClass: "active",
	mode: 'history',
	// scrollBehavior(to, from, savedPosition) {
	// 	return { x: 0, y: 0 }
	// }
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			console.log(to.hash);
			// return window.scrollTo({
			// 	top: document.querySelector(to.hash).offsetTop - 100,
			// 	behavior: 'smooth'
			// })
			return { selector: to.hash, behavior: 'smooth' }
		} else if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 }
		}
	}
});

export default router;
